import React from 'react';
import Slider from '../components/Slider';
import HeroSection from '../components/HeroSection';
const Home = () => {
  return (
    <div>
      <Slider />
      <HeroSection />
    </div>
  )
}

export default Home